import { render, staticRenderFns } from "./NoteIcon.vue?vue&type=template&id=74e67808&scoped=true"
import script from "./NoteIcon.vue?vue&type=script&lang=js"
export * from "./NoteIcon.vue?vue&type=script&lang=js"
import style0 from "./NoteIcon.vue?vue&type=style&index=0&id=74e67808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e67808",
  null
  
)

export default component.exports